/* Built In Imports */
/* External Imports */
import { Box, Flex } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Component */
// import config from '@config';

/* Styles */
/* Services */

/**
 * Renders JsonTableUI H Component
 * @param {Object} sectionContent - Data from api
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 * @returns {ReactElement} - JsonTableUI Component
 */
const JsonTableUI = ({ sectionContent, region, lang }) => {
  const data = sectionContent?.data;
  return Object.keys(data).map((key, value) => {
    return (
      <Flex key={nanoid(5)}>
        <Box
          w="40%"
          pos={'relative'}
          _after={{
            content: '":"',
            position: 'absolute',
            top: 0,
            right: 0,
          }}
          fontFamily="'FedraSansStd-book', sans-serif"
          fontSize="16px"
          color="#28231E"
          marginBottom="10px"
        >
          {key}
        </Box>
        <Box
          w="60%"
          fontFamily="'FedraSansStd-medium', sans-serif"
          fontSize="16px"
          color="#28231E"
          paddingLeft="45px"
          marginBottom="10px"
        >
          {data[key]}
        </Box>
      </Flex>
    );
  });
};

export default JsonTableUI;
